import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ChecklistIcon from "@mui/icons-material/Checklist";

export const wpeList = [
  {
    label: "Files",
    type: "file",
    Icon: InsertDriveFileIcon,
  },
  {
    label: "Tasks",
    type: "list",
    Icon: ChecklistIcon,
  },
];
